// export const CARD_DATA_REQUEST = 'CARD_DATA_REQUEST';
// export const CARD_DATA_SUCCESS = 'CARD_DATA_SUCCESS';
// export const CARD_DATA_ERROR = 'CARD_DATA_ERROR';


export const BOOKMARK_CARD_FLAG = 'BOOKMARK_CARD_FLAG';
export const FAVORITE_CARD_FLAG = 'FAVORITE_CARD_FLAG';